import { tracker, useBloc } from "src/state/state";
import HistoryBloc from "src/state/HistoryBloc/HistoryBloc";
import { FC, ReactNode, useEffect, useRef } from "react";
import { useBlocNext } from "@blac/react";
import TaskManagementBloc from "src/state/TaskManagementBloc/TaskManagementBloc";
import { KnownProgram } from "src/constants/programs";
import { Blac } from "blac-next";
import TaskListBloc from "../TaskList/TaskListBloc";
import reportErrorSentry from "src/lib/reportErrorSentry";

const AppAutoTriggers: FC = (): ReactNode => {
  const [{ history }, { getLastSearchParam }] = useBloc(HistoryBloc);
  const [{ tasks }, { getProgramTasks }] = useBlocNext(TaskManagementBloc);

  const triggerLog = useRef(new Set<string>());

  useEffect(() => {
    // auto trigger for tasks
    const lastProgramParam = getLastSearchParam("program");
    const lastGroupParam = getLastSearchParam("group");
    const lastSlugParam = getLastSearchParam("slug");

    if (lastProgramParam && lastSlugParam) {
      const identifier = `${lastProgramParam}-${lastGroupParam ?? "none"}-${lastSlugParam}`;
      let error = null;
      const onboardingTask = getProgramTasks(
        lastProgramParam as KnownProgram.ONBOARDING
      );
      const matchingTask = onboardingTask.find((task) => {
        const groupMatch = lastGroupParam
          ? task.group === lastGroupParam
          : true;
        const slugMatch = task.slug === lastSlugParam;
        return groupMatch && slugMatch;
      });

      if (matchingTask) {
        if (!triggerLog.current.has(identifier)) {
          triggerLog.current.add(identifier);
          const taskController = Blac.getBloc(TaskListBloc);

          const taskWithTrigger = taskController.processTasksWithConfig(
            [matchingTask],
            taskController.taskConfigMap,
            [matchingTask]
          );
          const triggerTask =
            taskWithTrigger.length > 0 ? taskWithTrigger[0] : null;

          if (triggerTask) {
            taskController.handleTaskClick(triggerTask);
            tracker.track("Auto Trigger Task", {
              data: {
                program: lastProgramParam,
                group: lastGroupParam,
                slug: lastSlugParam
              }
            });
          } else {
            error = new Error("No task to trigger for auto trigger");
          }
        }
      } else {
        error = new Error("No matching task found for auto trigger");
      }

      if (error && !triggerLog.current.has(`error-${identifier}`)) {
        triggerLog.current.add(`error-${identifier}`);

        reportErrorSentry(error, {
          extra: {
            lastProgramParam,
            lastGroupParam,
            lastSlugParam
          }
        });
      }
    }
  }, [history, tasks]);

  return <></>;
};

export default AppAutoTriggers;
